module.exports = __webpack_public_path__ + "img/report_img.aff2da69.jpg";